module.exports = __webpack_public_path__ + "img/c4044b7.png";